import { render, staticRenderFns } from "./resumeApplySuccess.vue?vue&type=template&id=732cbde2&scoped=true"
import script from "./resumeApplySuccess.vue?vue&type=script&lang=js"
export * from "./resumeApplySuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732cbde2",
  null
  
)

export default component.exports